<tp-modal [dialogTitle]="data.title" [isBusy]="isSubmitting$ | async">
  <div style="display: flex; flex-direction: column; align-items: center">
    @if (data.body) {
      <p class="modal-content-wrapper">{{ data.body }}</p>
    }
    @if (data.warning) {
      <div class="admonitionblock attention">
        <div class="icon">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
        <p>{{ data.warning }}</p>
      </div>
    }
    <tp-form-actions
      [submitText]="data.confirmText || 'Confirm'" [submitButtonStyle]="data.confirmButtonStyle || 'primary-outline green stroke'"
      buttonIdPrefix="confirmationModal"
      [isSubmitting]="isSubmitting$ | async" (submitClick)="confirm()" [cancellable]="true" (cancel)="close()"
    />
  </div>
</tp-modal>
